/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesCustomerAnswerType } from './WebApiModelsEnumerationTypesCustomerAnswerType';
import {
    WebApiModelsEnumerationTypesCustomerAnswerTypeFromJSON,
    WebApiModelsEnumerationTypesCustomerAnswerTypeFromJSONTyped,
    WebApiModelsEnumerationTypesCustomerAnswerTypeToJSON,
} from './WebApiModelsEnumerationTypesCustomerAnswerType';

/**
 * A time of an event, with the member's own answer for it.
 * @export
 * @interface WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDto
 */
export interface WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDto {
    /**
     * Start of the time.
     * @type {Date}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDto
     */
    start?: Date;
    /**
     * End of the time.
     * @type {Date}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDto
     */
    end?: Date;
    /**
     * True when the time lasts the whole day.
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDto
     */
    isFullDay?: boolean;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesCustomerAnswerType}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDto
     */
    answer?: WebApiModelsEnumerationTypesCustomerAnswerType;
    /**
     * True when a member without a place can't get one.
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDto
     */
    isFullyBooked?: boolean;
    /**
     * True when the time is fully booked but the waitlist still takes new guests.
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDto
     */
    isWaitlistOpen?: boolean;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDtoFromJSON(json: any): WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDto {
    return WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'start': !exists(json, 'start') ? undefined : (new Date(json['start'])),
        'end': !exists(json, 'end') ? undefined : (new Date(json['end'])),
        'isFullDay': !exists(json, 'isFullDay') ? undefined : json['isFullDay'],
        'answer': !exists(json, 'answer') ? undefined : WebApiModelsEnumerationTypesCustomerAnswerTypeFromJSON(json['answer']),
        'isFullyBooked': !exists(json, 'isFullyBooked') ? undefined : json['isFullyBooked'],
        'isWaitlistOpen': !exists(json, 'isWaitlistOpen') ? undefined : json['isWaitlistOpen'],
    };
}

export function WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDtoToJSON(value?: WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'start': value.start === undefined ? undefined : (value.start.toISOString()),
        'end': value.end === undefined ? undefined : (value.end.toISOString()),
        'isFullDay': value.isFullDay,
        'answer': WebApiModelsEnumerationTypesCustomerAnswerTypeToJSON(value.answer),
        'isFullyBooked': value.isFullyBooked,
        'isWaitlistOpen': value.isWaitlistOpen,
    };
}

